import { takeEvery, takeLatest } from 'redux-saga/effects';
import {
  connectToPhoneBridgeRequested,
  disconnectFromPhoneBridgeRequested,
  muteRemotePhoneUserRequested,
  phoneUserLowerHand,
  signalingPhoneBridgeDisconnected,
  signalingPhoneStreamStarted,
  signalingPhoneUserHandLowered,
  signalingPhoneUserHandRaised,
  unmuteRemotePhoneUserRequested,
} from 'features/sip/actions';
import { connectToPhoneBridgeSaga } from 'features/sip/sagas/connectToPhoneBridgeSaga';
import { disconnectFromPhoneBridgeSaga } from 'features/sip/sagas/disconnectFromPhoneBridgeSaga';
import { onPhoneStreamStartSaga } from 'features/sip/sagas/onPhoneStreamStartSaga';
import { onPhoneBridgeDisconnectSaga } from 'features/sip/sagas/onPhoneBridgeDisconnectSaga';
import { muteRemotePhoneAudioSaga } from 'features/sip/sagas/muteRemotePhoneAudioSaga';
import { unmuteRemotePhoneAudioSaga } from 'features/sip/sagas/unmuteRemotePhoneAudioSaga';
import { onPhoneUserHandRaisedSaga } from 'features/sip/sagas/onPhoneUserHandRaisedSaga';
import { onPhoneUserHandLoweredSaga } from 'features/sip/sagas/onPhoneUserHandLoweredSaga';
import { lowerPhoneUserHandSaga } from 'features/sip/sagas/lowerPhoneUserHandSaga';
import { onHandRaiseDismissedSaga } from 'features/users/sagas/onHandRaiseDismissedSaga';
import { phoneHandRaiseDismissed } from 'features/sip/sipSlice';

export default function* sipWatcher() {
  yield takeLatest(connectToPhoneBridgeRequested, connectToPhoneBridgeSaga);
  yield takeLatest(disconnectFromPhoneBridgeRequested, disconnectFromPhoneBridgeSaga);
  yield takeLatest(signalingPhoneBridgeDisconnected, onPhoneBridgeDisconnectSaga);

  yield takeLatest(signalingPhoneStreamStarted, onPhoneStreamStartSaga);

  yield takeEvery(muteRemotePhoneUserRequested, muteRemotePhoneAudioSaga);
  yield takeEvery(unmuteRemotePhoneUserRequested, unmuteRemotePhoneAudioSaga);

  yield takeEvery(phoneUserLowerHand, lowerPhoneUserHandSaga);
  yield takeEvery(signalingPhoneUserHandRaised, onPhoneUserHandRaisedSaga);
  yield takeEvery(signalingPhoneUserHandLowered, onPhoneUserHandLoweredSaga);
  yield takeEvery(phoneHandRaiseDismissed, onHandRaiseDismissedSaga);
}
